import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

// Ciclo: el auto acelera en el lugar (humo), arranca y cruza la portada.
const DRIVE = 4.6;
const PAUSE = 1.2;
const CYCLE = DRIVE + PAUSE;
const START = '3%';
const puffs = [{
  delay: 0.05,
  size: 18,
  y: -6
}, {
  delay: 0.35,
  size: 24,
  y: -10
}, {
  delay: 0.65,
  size: 20,
  y: -4
}, {
  delay: 0.95,
  size: 28,
  y: -14
}, {
  delay: 1.25,
  size: 22,
  y: -8
}];

/** Autito LED que acelera, larga humo y cruza la portada del catálogo. */
export function LedCar() {
  const reduce = useReducedMotion();
  if (reduce) {
    return <div className="pointer-events-none absolute bottom-3 right-6" aria-hidden data-id="element-429" data-mp="2qnjgkwlpa5cn">
        <CarSvg spinning={false} data-id="element-430" data-mp="2vn5ul89crpmi" />
      </div>;
  }
  return <div className="pointer-events-none absolute inset-x-0 bottom-2 h-14 overflow-hidden" aria-hidden data-id="element-431" data-mp="2vme5mga9gq57">
      {/* Línea de pista LED */}
      <div className="absolute inset-x-0 bottom-1 h-px bg-neon/40 shadow-[0_0_8px_rgba(20,99,255,0.8)]" data-id="element-432" data-mp="118v1gnlq69ax" />

      {/* Humo: queda en el punto de largada mientras el auto se va */}
      {puffs.map((p, i) => <motion.span key={i} className="absolute rounded-full bg-silver/50 blur-[6px]" style={{
      left: `calc(${START} - 4px)`,
      bottom: 10,
      width: p.size,
      height: p.size
    }} initial={{
      opacity: 0,
      scale: 0.3,
      x: 0,
      y: 0
    }} animate={{
      opacity: [0, 0.75, 0],
      scale: [0.3, 1.4, 2.4],
      x: [0, -18, -46],
      y: [0, p.y, p.y - 14]
    }} transition={{
      duration: 1.5,
      delay: p.delay,
      ease: 'easeOut',
      repeat: Infinity,
      repeatDelay: CYCLE - 1.5
    }} data-id="element-433" data-mp="z5wxhisj1rjq" data-mpi={i} />)}

      <motion.div className="absolute bottom-1.5" initial={{
      left: START
    }} animate={{
      left: [START, START, '108%']
    }} transition={{
      duration: DRIVE,
      times: [0, 0.32, 1],
      ease: [0.55, 0, 0.75, 0.4],
      repeat: Infinity,
      repeatDelay: PAUSE
    }} data-id="element-434" data-mp="1cx21ex2xh5zv">
        {/* Vibración del motor */}
        <motion.div animate={{
        y: [0, -1, 0, 0.8, 0]
      }} transition={{
        duration: 0.18,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-435" data-mp="3tlo1kqxbl1sx">
          <CarSvg spinning data-id="element-436" data-mp="3v4e6hi8g1t34" />
        </motion.div>
      </motion.div>
    </div>;
}
function CarSvg({
  spinning
}: {
  spinning: boolean;
}) {
  const wheel = (cx: number) => <g data-id="element-437" data-mp="3l4nd5jvmdk4m">
      <circle cx={cx} cy="34" r="7" fill="#05173A" stroke="#4D8CFF" strokeWidth="2" data-id="element-438" data-mp="3l4x5he4503dh" />
      <motion.g style={{
      originX: `${cx}px`,
      originY: '34px'
    }} animate={spinning ? {
      rotate: 360
    } : undefined} transition={{
      duration: 0.4,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-439" data-mp="3q3i3d6vx2ayr">
        <line x1={cx - 5} y1="34" x2={cx + 5} y2="34" stroke="#EEF2F7" strokeWidth="1.4" data-id="element-440" data-mp="3h5ekkicbfsan" />
        <line x1={cx} y1="29" x2={cx} y2="39" stroke="#EEF2F7" strokeWidth="1.4" data-id="element-441" data-mp="32ga0swpvhg0f" />
      </motion.g>
    </g>;
  return <svg width="104" height="44" viewBox="0 0 104 44" className="drop-shadow-[0_0_6px_rgba(77,140,255,0.95)]" data-id="element-442" data-mp="37ebj3ffh5bau">
      {/* Carrocería */}
      <path d="M6 33 L6 25 Q6 21 11 20 L28 17 L40 8 Q43 6 48 6 L68 6 Q73 6 76 9 L86 18 L95 20 Q99 21 99 25 L99 33 Z" fill="#0A2554" stroke="#4D8CFF" strokeWidth="2" strokeLinejoin="round" data-id="element-443" data-mp="2xfmayeddr57s" />
      {/* Ventanillas */}
      <path d="M33 18 L43 10 L56 10 L56 18 Z M60 18 L60 10 L70 10 Q72 10 74 12 L80 18 Z" fill="#1463FF" opacity="0.55" data-id="element-444" data-mp="29ubmnzn2cgs6" />
      {/* Faro y luz trasera */}
      <rect x="94" y="22" width="5" height="3" rx="1" fill="#EEF2F7" data-id="element-445" data-mp="2isw0amdro09j" />
      <rect x="6" y="23" width="3" height="3" rx="1" fill="#F87171" data-id="element-446" data-mp="2xqfztdrw938b" />
      {wheel(25)}
      {wheel(80)}
    </svg>;
}